<div class="wizard-container">
  <div class="wizard-header">
    <div class="header-top">
      <h2 class="table-title">{{ 'i18n.domain.product-template.publishing-wizard.wizard-title' | translate }}</h2>
      <div class="header-buttons">
        <p-button label="{{ 'i18n.shared.back' | translate }}" icon="pi pi-arrow-left" [text]="true" (onClick)="goBack()"></p-button>
        <p-button label="{{ 'i18n.shared.close' | translate }}" icon="pi pi-times" [text]="true" (onClick)="close()"></p-button>
      </div>
    </div>
    <div class="step-indicator">
      <div class="step" [class.active]="currentStep === 1" [class.completed]="currentStep > 1">
        <span class="step-label">{{ 'i18n.domain.product-template.publishing-wizard.step1' | translate }}</span>
        <span class="step-description">{{ 'i18n.domain.product-template.publishing-wizard.select-templates' | translate }}</span>
      </div>
      <div class="step" [class.active]="currentStep === 2" [class.completed]="currentStep > 2">
        <span class="step-label">{{ 'i18n.domain.product-template.publishing-wizard.step2' | translate }}</span>
        <span class="step-description">{{ 'i18n.domain.product-template.publishing-wizard.set-details' | translate }}</span>
      </div>
      <div class="step" [class.active]="currentStep === 3">
        <span class="step-label">{{ 'i18n.domain.product-template.publishing-wizard.step3' | translate }}</span>
        <span class="step-description">{{ 'i18n.domain.product-template.publishing-wizard.summary-title' | translate }}</span>
      </div>
    </div>
  </div>
  <div class="wizard-content">
    <app-template-selection *ngIf="currentStep === 1" (templatesSelected)="onTemplatesSelected($event)"></app-template-selection>
    <app-conflict-detection *ngIf="currentStep === 2" [conflicts]="conflicts" [selectedTemplateIds]="selectedTemplateIds" [templateOverrides]="templateOverrides" [sellerProfileId]="selectedSellerProfileId" (conflictsResolved)="onConflictsResolved($event)"></app-conflict-detection>
    <app-publishing-summary *ngIf="currentStep === 3" [publishRequests]="publishRequests" [publishedProducts]="publishedProducts" (publish)="onPublish()"></app-publishing-summary>
  </div>
</div>
